"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.populateCardProduct = exports.mapInjectedCardDetailsToRegistry = exports.mapCustomerProductsRegistry = exports.mapCustomerProductDetails = exports.mapCardProductsRegistry = exports.mapCardProductDetails = exports.getIsCustomerProductsMarket = exports.getFlags = void 0;
var _constants = require("./constants");
var _selectors = require("./selectors");
const mapInjectedCardDetailsToRegistry = _ref => {
  let {
    productsOrder,
    productsList
  } = _ref;
  return {
    [_constants.CARD_PRODUCT]: productsOrder.map(token => {
      const {
        account_token: accountToken,
        account_key: accountKey
      } = productsList[token];
      return {
        type: _constants.CARD_PRODUCT,
        accountToken,
        accountKey,
        opaqueAccountId: accountToken
      };
    })
  };
};
exports.mapInjectedCardDetailsToRegistry = mapInjectedCardDetailsToRegistry;
const mapCardProductsRegistry = _ref2 => {
  let {
    accounts = []
  } = _ref2;
  return {
    [_constants.CARD_PRODUCT]: accounts.map(_ref3 => {
      let {
        account_token: accountToken,
        account_key: accountKey
      } = _ref3;
      return {
        type: _constants.CARD_PRODUCT,
        accountToken,
        accountKey,
        opaqueAccountId: accountToken
      };
    })
  };
};
exports.mapCardProductsRegistry = mapCardProductsRegistry;
const mapCustomerProductsRegistry = (response, types) => {
  const returnedProductsByType = response.reduce((accum, _ref4) => {
    let {
      type,
      ...productData
    } = _ref4;
    return {
      ...accum,
      [type]: [...(accum[type] ? accum[type] : []), {
        type,
        ...productData
      }]
    };
  }, {});

  // return all types, regardless of full/partial response or no accounts existing
  return types.reduce((accum, type) => ({
    ...accum,
    [type]: returnedProductsByType[type] || []
  }), {});
};
exports.mapCustomerProductsRegistry = mapCustomerProductsRegistry;
const propertyMap = {
  accountTypes: ['WorkingCapitalTerms'],
  relationship: ['BASIC', 'SUPP'],
  lineOfBusinessType: ['CONSUMER', 'CORPORATE', 'CO_BRAND_CARD', 'COMPANY_CARD', 'PERSONAL_SAVINGS'],
  paymentType: ['CHARGE', 'REVOLVE', 'TERMLOAN', 'LINEOFCREDITACCOUNT'],
  roles: ['AUTHORIZED_MANAGER_FULL', 'AUTHORIZED_MANAGER_LIMITED']
};

// Returns object map of flags found in product data.
const getFlags = _ref5 => {
  let {
    product: {
      account_types: accountTypes = [],
      payment_type: paymentType,
      line_of_business_type: lineOfBusinessType
    } = {},
    account: {
      relationship
    } = {},
    authorized_user_profile: {
      roles = []
    } = {}
  } = _ref5;
  const properties = {
    accountTypes,
    paymentType,
    lineOfBusinessType,
    relationship,
    roles
  };

  // Reduce all entries in the property map to build full list of flags.
  return Object.keys(propertyMap).reduce((flags, property) => ({
    ...flags,
    // Reduce each value per property to build flags within each property;
    ...propertyMap[property].reduce((propertyFlags, value) => {
      const hasProperty = Array.isArray(properties[property]) ? properties[property].includes(value) : properties[property] === value;
      const propertyLabel = `is${value.charAt(0).toUpperCase()}${value.slice(1).toLowerCase()}`;
      return {
        ...propertyFlags,
        ...(hasProperty ? {
          [propertyLabel]: true
        } : {})
      };
    }, {})
  }), {});
};

// Populates individual additional product data.
exports.getFlags = getFlags;
const populateCardProduct = _ref6 => {
  let {
    account_token: accountToken,
    supplementary_accounts: supps,
    ...productData
  } = _ref6;
  return {
    [accountToken]: {
      ...productData,
      account_token: accountToken,
      _flags: getFlags(productData),
      ...(supps ? {
        supplementary_accounts: supps.map(supp => supp.account_token)
      } : {})
    }
  };
};
exports.populateCardProduct = populateCardProduct;
const mapCardProductDetails = _ref7 => {
  let {
    accounts = []
  } = _ref7;
  // Order consists of main returned accounts, represents "selectable" products.
  const productsOrder = accounts.map(product => product.account_token);

  // self-issued supps have the same cards in both the primary list and in the supplemental_accounts
  // list. products in the supplemental_accounts list do not contain the same amount of data as
  // products in the primary list. we must avoid overwriting of products in the primary list by
  // products in the supplemental_accounts list.
  const supps = accounts.reduce((allSupps, _ref8) => {
    let {
      supplementary_accounts: acctSupps
    } = _ref8;
    return acctSupps ? [...allSupps, ...acctSupps] : allSupps;
  }, []);
  const productsList = [...accounts, ...supps].reduce((accum, product) => {
    const populatedCardProduct = accum[product.account_token] ? {} : populateCardProduct(product);
    return {
      ...accum,
      ...populatedCardProduct
    };
  }, {});
  return {
    productsOrder,
    productsList
  };
};
exports.mapCardProductDetails = mapCardProductDetails;
const populateProductTypeDetails = details => details.reduce((accum, _ref9) => {
  let {
    opaqueAccountId,
    ...accountData
  } = _ref9;
  return {
    productsOrder: [...(accum.productsOrder || []), opaqueAccountId],
    productsList: {
      ...(accum.productsList || {}),
      [opaqueAccountId]: {
        opaqueAccountId,
        ...accountData
      }
    }
  };
}, {});
const mapCustomerProductDetails = (_ref10, types) => {
  let {
    results = {}
  } = _ref10;
  const returnedProductsByType = Object.entries(results).reduce((accum, _ref11) => {
    let [type, details] = _ref11;
    return {
      ...accum,
      [type]: populateProductTypeDetails(details)
    };
  }, {});

  // return all types, regardless of full/partial response or no accounts existing
  return types.reduce((accum, type) => ({
    ...accum,
    [type]: returnedProductsByType[type] || {
      productsOrder: [],
      productsList: {}
    }
  }), {});
};
exports.mapCustomerProductDetails = mapCustomerProductDetails;
const getIsCustomerProductsMarket = locale => {
  const markets = (0, _selectors.getCustomerProductMarkets)();
  if (markets.length === 0) {
    return true;
  }
  const [, market] = locale.split('-');
  return markets.includes(market);
};
exports.getIsCustomerProductsMarket = getIsCustomerProductsMarket;